import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import {
  MatSidenav,
  MatSidenavContainer, MatSidenavContent
} from '@angular/material/sidenav';

import { MatIcon } from '@angular/material/icon';
import { NgStyle } from '@angular/common';
import { UsersManagerStore } from '@data-access/manager/stores/users-manager.store';
import { TracksManagerStore } from '@data-access/manager/stores/tracks-manager.store';
import { GenresManagerStore } from '@data-access/manager/stores/genres-manager.store';
import { SubGenresManagerStore } from '@data-access/manager/stores/subgenres-manager.store';
import { CategoriesManagerStore } from '@data-access/manager/stores/categories-manager.store';
import { PlaylistsManagerStore } from '@data-access/manager/stores/playlists-manager.store';

@Component({
  selector: 'app-manager',
  imports: [
    RouterOutlet,
    RouterLink,

    MatSidenavContainer,
    MatSidenav,
    MatSidenavContent,

    MatIcon,
    RouterLinkActive,
    NgStyle
  ],
  providers: [
    UsersManagerStore,
    TracksManagerStore,
    GenresManagerStore,
    SubGenresManagerStore,
    CategoriesManagerStore,
    PlaylistsManagerStore,
  ],
  templateUrl: './manager.html',
  styleUrl: './manager.scss'
})
export class Manager {
  sidenavWidth = 12;
  isSettingsOpen = false;
  isSidenavOpen = true;
  toggle() {
    this.isSettingsOpen = !this.isSettingsOpen;
  }

  toggleMenu() {
    this.isSidenavOpen = !this.isSidenavOpen
    this.sidenavWidth = this.isSidenavOpen ? 12 : 4;
  }

  // increase() {
  //   this.sidenavWidth = 13;
  //   console.log('increase sidenav width');
  // }
  // decrease() {
  //   this.sidenavWidth = 3;
  //   console.log('decrease sidenav width');
  // }
}
